import { render, staticRenderFns } from "./ProjectsComponent.vue?vue&type=template&id=1a0bbe5c&scoped=true&"
import script from "./ProjectsComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsComponent.vue?vue&type=style&index=0&id=1a0bbe5c&lang=scss&scoped=true&"
import style1 from "./ProjectsComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0bbe5c",
  null
  
)

export default component.exports